import React from 'react'
import { browserHistory } from 'react-router'
import update from 'immutability-helper';
import { modal } from '../../../core/utilities/modal';
import { phoneNumberFormatter } from '../../../helpers/General/PhoneNunberFormatter'

import { payable } from '../../../core/controllers/Payable'
import UnitedStatesSelect from '../../../helpers/General/UnitedStatesSelect';

export default class VendorEdit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            newVendor: props.newVendor ? true : false,
            sortID: null,
            vendor: {
                vendor_id: props.vendorId,
                firstname: '',
                lastname: '',
                phone: '',
                email: '',
                company_name: '',
                address: '',
                city: '',
                state: '',
                zip: '',
                description: ''
            },
        };
    }

    componentDidMount() {
        var self = this;
        if (!this.props.newVendor) {
            payable.getVendor(this.props.vendorId, function(response) {
                self.setState({vendor: response.data});
            });
        }
    }

    handleCreateVendor() {
        if(!this.validateData()){
            return;
        }
        const vendorDetail = this.state.vendor;
        modal.showDangerModalWithOK("Are you sure?", "Vendors will automatically be notified of their new account to submit bills.", "Yes, Create!");
		jQuery(".move-on").on('click',function() {
            payable.createVendor(vendorDetail, function(response) {
                modal.resetBackDrop();
                modal.showSuccess('Successfully Created!', 'This vendor was successfully created!');
                jQuery(".move-on").on('click',function() {
                    browserHistory.goBack();
                });
            });
        });
    }

    handleUpdateVendor() {
        if(!this.validateData()){
            return;
        }
        const vendorDetail = this.state.vendor;
        payable.updateVendor(this.props.vendorId, vendorDetail, function(response) {
            modal.resetBackDrop();
            modal.showSuccess('Successfully Updated!', 'This vendor was successfully updated!');
            jQuery(".move-on").on('click',function() {
                browserHistory.goBack();
            });
        });
    }

    handleDeleteVendor() {
        if(!this.validateData()){
            return;
        }
        var self = this;
        modal.showDangerModalWithOK("Are you sure?", "This vendor will be deleted and they will be unable to access their account.", "Yes, Delete!");
		jQuery(".move-on").on('click',function() {
            payable.deleteVendor(self.props.vendorId, function(response) {
                modal.resetBackDrop();
                modal.showSuccess('Successfully deleted!', 'This vendor was successfully deleted!');
                jQuery(".move-on").on('click',function() {
                    browserHistory.goBack();
                });
            });
        });
    }

    handleFirstNameChange(e){
        this.setState({
            vendor: update(this.state.vendor, {
                firstname: {$set: e.target.value}
            })
        });
    }

    handleLastNameChange(e){
        this.setState({
            vendor: update(this.state.vendor, {
                lastname: {$set: e.target.value}
            })
        });
    }

    handlePhoneChange(e){
        var phoneNumber = phoneNumberFormatter.format(e.target.value);

        this.setState({
            vendor: update(this.state.vendor, {
                phone: {$set: phoneNumber}
            })
        });
    }

    handleEmailChange(e){
        this.setState({
            vendor: update(this.state.vendor, {
                email: {$set: e.target.value}
            })
        });
    }

    handleCompanyNameChange(e){
        this.setState({
            vendor: update(this.state.vendor, {
                company_name: {$set: e.target.value}
            })
        });
    }

    handleAddressChange(e){
        this.setState({
            vendor: update(this.state.vendor, {
                address: {$set: e.target.value}
            })
        });
    }

    handleCityChange(e){
        this.setState({
            vendor: update(this.state.vendor, {
                city: {$set: e.target.value}
            })
        });
    }

    handleStateChange(e){
        this.setState({
            vendor: update(this.state.vendor, {
                state: {$set: e.target.value}
            })
        });
    }

    handleZipChange(e){
        this.setState({
            vendor: update(this.state.vendor, {
                zip: {$set: e.target.value}
            })
        });
    }

    handleDescriptionChange(e){
        this.setState({
            vendor: update(this.state.vendor, {
                description: {$set: e.target.value}
            })
        });
    }

    validateData() {
        const vendor = this.state.vendor;
        const first_name = vendor.firstname;
        const phone = vendor.phone;
        const email = vendor.email;
        const company_name = vendor.company_name;
        const address = vendor.address;

        if (first_name == null || first_name.length == 0) {
            modal.showInfo("Enter the vendor's name!", "warning", "top", "center");
            return false;
        }  else if (phone == null || phone.length == 0) {
            modal.showInfo("Enter a phone number for the vendor!", "warning", "top", "center");
            return false;
        } else if (email == null || email.length == 0) {
            modal.showInfo("Enter an email for the vendor!", "warning", "top", "center");
            return false;
        } else if (company_name == null || company_name.length == 0) {
            modal.showInfo("Enter a company name for the vendor!", "warning", "top", "center");
            return false;
        } else if (address == null || address.length == 0) {
            modal.showInfo("Enter an address for the vendor!", "warning", "top", "center");
            return false;
        }

        return true;
    }

    render(){
        const vendorFirstName = this.state.vendor.firstname;
        const vendorLastName = this.state.vendor.lastname;
        const vendorPhone = this.state.vendor.phone;
        const vendorEmail = this.state.vendor.email;
        const vendorCompanyName = this.state.vendor.company_name;
        const vendorAddress = this.state.vendor.address;
        const vendorCity = this.state.vendor.city;
        const vendorState = this.state.vendor.state;
        const vendorZip = this.state.vendor.zip;
        const vendorDescription = this.state.vendor.description;
        const newVendor = this.state.newVendor;

        return (
        <div>
            <div class="row blue-bottom-margin">
                <div class="row">
                    <div class="sub-page-header-row col-md-11">
                        <div class="row">
                            <span class="sub-page-header-title">{newVendor == true ? "Add a Vendor" : vendorFirstName + " " + vendorLastName}</span>
                        </div>
                    </div>
                </div>
                <div class="col-sm-12 col-xs-12">
                    <div class="col-md-12 card">
                        <div class="content">
                            <div class="header">
                                <h4 class="title">Vendor Information</h4>
                                <p class="category">Vendors can use their phone number or email to login and submit invoices.</p>
                            </div>
                            <div class="content" style={{marginTop: "15px"}, {justifyContent: "space-between"}}>
                                <div class="col-md-12 col-lg-12">
                                    <div class="row">
                                        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                            <div class="form-group">
                                                <label>First Name</label>
                                                <input type="text" class="form-control" first_name="first_name" placeholder="First Name" value={vendorFirstName} onChange={this.handleFirstNameChange.bind(this)}/>
                                            </div>
                                        </div>
                                        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                            <div class="form-group">
                                                <label>Last Name</label>
                                                <input type="text" class="form-control" last_name="last_name" placeholder="Last Name" value={vendorLastName} onChange={this.handleLastNameChange.bind(this)}/>
                                            </div>
                                        </div>
                                        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                            <div class="form-group">
                                                <label>Phone</label>
                                                <input type="text" class="form-control" phone="" placeholder="Phone" value={vendorPhone} onChange={this.handlePhoneChange.bind(this)}/>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        { newVendor == true ? (
                                        <div class="col-lg-4 col-md-4 col-sm-8 col-xs-12">
                                            <div class="form-group">
                                                <label>Email</label>
                                                <input type="text" class="form-control" email="" placeholder="user@example.com" value={vendorEmail} onChange={this.handleEmailChange.bind(this)}/>
                                            </div>
                                        </div>
                                        ) : (
                                        <div class="col-lg-4 col-md-4 col-sm-8 col-xs-12">
                                            <div class="form-group">
                                                <label>Email</label>
                                                <input type="text" class="form-control" disabled email="" placeholder="user@example.com" value={vendorEmail} onChange={this.handleEmailChange.bind(this)}/>
                                            </div>
                                        </div>
                                        )}
                                        <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                                            <div class="form-group">
                                                <label>Company Name</label>
                                                <input type="text" class="form-control" company_name="" placeholder="Company Name" value={vendorCompanyName} onChange={this.handleCompanyNameChange.bind(this)}/>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-5 col-md-5 col-sm-9 col-xs-12">
                                            <div class="form-group">
                                                <label>Address</label>
                                                <input type="text" class="form-control" address="" placeholder="Address" value={vendorAddress} onChange={this.handleAddressChange.bind(this)}/>
                                            </div>
                                        </div>
                                        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                            <div class="form-group">
                                                <label>City</label>
                                                <input type="text" class="form-control" city="" placeholder="City" value={vendorCity} onChange={this.handleCityChange.bind(this)}/>
                                            </div>
                                        </div>
                                        <div class="col-lg-3 col-md-3 col-sm-4 col-xs-12">
                                            <div class="form-group">
                                                <UnitedStatesSelect columnSize={0} sortID={vendorState} title="State*" onChange={this.handleStateChange.bind(this)}/>
                                            </div>
                                        </div>
                                        <div class="col-lg-2 col-md-2 col-sm-4 col-xs-12">
                                            <div class="form-group">
                                                <label>Zipcode</label>
                                                <input type="text" class="form-control" zip="" placeholder="Zipcode" value={vendorZip} onChange={this.handleZipChange.bind(this)}/>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <div class="form-group">
                                                <label>Description</label>
                                                <textarea rows="4" type="text" class="form-control" description="" placeholder="Description of vendor services" value={vendorDescription} onChange={this.handleDescriptionChange.bind(this)}/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row blue-bottom">
                <div class="blue-bottom-center-align">
                    {newVendor ? (
                    <div class="col-md-12">
                        <button type="button" id="create-vendor" data-loading-text="Loading..." class="btn btn-primary btn-info btn-fill" autoComplete="off" onClick={this.handleCreateVendor.bind(this)}>
                        Create Vendor
                        </button>
                    </div>
                    ) : (
                    <div>
                        <div class="col-md-6 col-sm-6 col-xs-12 blue-bottom-btn-right-push">
                            <button type="button" id="delete-vendor" data-loading-text="Loading..." class="btn btn-danger btn-info btn-fill" autoComplete="off" onClick={this.handleDeleteVendor.bind(this)}>
                                Delete Vendor
                            </button>
                        </div>
                        <div class="col-md-3 col-sm-6 col-xs-12">
                            <button type="button" id="update-vendor" data-loading-text="Loading..." class="btn btn-info btn-fill" autoComplete="off" onClick={this.handleUpdateVendor.bind(this)}>
                                Update Vendor
                            </button>
                        </div>
                    </div>
                    )}
                    <div class="clearfix"></div>
                </div>
            </div>
        </div>
        )
    }
};



// WEBPACK FOOTER //
// app/components/Payables/Vendor/VendorEdit.jsx